import toSearchParams from './to-search-params'
import { show, trackSearch } from '../../twd/twd'

export default (values) => {
    if (!values) return

    let p = toSearchParams(Object.assign({isSubmit:true}, values))
    setTimeout(() => {
        trackSearch('Advanced Screener', p, true)
    })

    show('offerings', Object.assign({
        searchParams: Object.assign(p, {persistToPreviousSearches:true}),
        _ts: Date.now(),
        from:'advanced-screener'
    }))
}


// WEBPACK FOOTER //
// ./src/advanced-screener/search-form/submit.js